import { useContext, useMemo } from 'react';
import { SearchingStatuses } from './state';
import { SearchPageContext } from './types';

/**
 * @returns true if waiting on XHR request(s) to complete
 */
export const useIsSearching = () => {
  const {
    pageState: { status },
  } = useContext(SearchPageContext);

  return useMemo(() => SearchingStatuses.includes(status), [status]);
};
